import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

// IMPORTANT: Replace with your app's Firebase project configuration
const firebaseConfig = {
 apiKey: "AIzaSyDWay7-gVkpK7vMHiYC6bd9U2K8BVvB-XI",
		authDomain: "hairygoats-budget-tracker.firebaseapp.com",
		projectId: "hairygoats-budget-tracker",
		storageBucket: "hairygoats-budget-tracker.firebasestorage.app",
		messagingSenderId: "1009484729182",
		ppId: "1:1009484729182:web:ca94da8d0fa867a9425dcf",
		measurementId: "G-NV485FH3BT"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export the services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);